import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/PhoneCall.es.js";
const e = o.forwardRef((a, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...a, weights: n }));
e.displayName = "PhoneCallIcon";
const c = e;
export {
  c as PhoneCall,
  e as PhoneCallIcon
};
